/* global google */
import React from 'react';
import { withRouter } from 'react-router-dom';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { GoogleMap, HeatmapLayer } from '@react-google-maps/api';
import { InputLabel, Switch, Grid } from '@mui/material';

import LocationMarkers from './location-markers';
import locationActions from '../../../actions/locations';
import routeActions from '../../../actions/routes';
import { getBoundsZoomLevel, LocationTypeNames } from '../../../lib/utils';

function BasicMap(props) {
  return (
    <GoogleMap
      mapContainerStyle={{ width: '100%', height: '100%' }}
      zoom={props.zoom}
      center={props.center}
    >
      <HeatmapLayer
        data={props.heatMap}
        options={{
          maxIntensity: 10,
        }}
      />
      {props.showStations && (
      <LocationMarkers
        locations={props.locations.filter((loc) => loc.type === LocationTypeNames.STATION)}
        onClick={() => {}}
      />
      )}
      {props.showHubs && (
      <LocationMarkers
        locations={props.locations.filter((loc) => loc.type === LocationTypeNames.HUB)}
        onClick={() => {}}
      />
      )}
    </GoogleMap>
  );
}

class BaseHeatMap extends React.Component {
  static DEFAULT_ZOOM_LEVEL = 15;

  static DEFAULT_LAT = 0;

  static DEFAULT_LNG = 0;

  static DEFAULT_CENTER = { lat: BaseHeatMap.DEFAULT_LAT, lng: BaseHeatMap.DEFAULT_LNG };

  constructor(props) {
    super(props);

    const { heatMap } = props;

    let center = BaseHeatMap.DEFAULT_CENTER;
    let zoom = BaseHeatMap.DEFAULT_ZOOM_LEVEL;

    const mapBounds = new google.maps.LatLngBounds();
    heatMap.forEach((val) => {
      mapBounds.extend({ lat: val.lat(), lng: val.lng() });
    });
    // height rounded down to 712 - weird issues noticed on differnt screen sizes
    zoom = getBoundsZoomLevel(mapBounds, {
      width: document.documentElement.clientWidth,
      height: Math.min(document.documentElement.clientHeight, 712),
    }) - 1;

    center = mapBounds.getCenter();
    this.state = {
      zoom,
      center,
      showStations: true,
      showHubs: true,
    };
  }

  async componentDidMount() {
    const { selectedMarket, fetchLocations } = this.props;
    if (selectedMarket) {
      const query = { market_id: selectedMarket };
      await fetchLocations(query);
    }
  }

  componentWillUnmount() {
    const { clearHeatMapData } = this.props;
    clearHeatMapData();
  }

  render() {
    const {
      zoom, center, showStations, showHubs,
    } = this.state;
    const { heatMap } = this.props;
    const locations = get(this, 'props.locations', []);

    return (
      <div id="map" style={{ height: '550px', width: '100%' }}>
        <BasicMap
          ref={(ref) => {
            this.map = ref;
          }}
          containerElement={<div style={{ height: '100%' }} />}
          mapElement={<div style={{ height: '100%' }} />}
          zoom={zoom}
          center={center}
          heatMap={heatMap}
          locations={locations}
          showHubs={showHubs}
          showStations={showStations}
        />
        <Grid container>
          <Grid item xs={12}>
            <Switch
              checked={showStations}
              onClick={() => this.setState({ showStations: !showStations })}
            />
            <InputLabel>
              Show Stations
            </InputLabel>
          </Grid>
          <Grid item xs={12}>
            <Switch
              checked={showHubs}
              onClick={() => this.setState({ showHubs: !showHubs })}
            />
            <InputLabel>
              Show Hubs
            </InputLabel>
          </Grid>
        </Grid>
      </div>
    );
  }
}

BaseHeatMap.defaultProps = {
  heatMap: [],
};
BaseHeatMap.propTypes = {
  heatMap: PropTypes.arrayOf(PropTypes.object),
};

const mapStateToProps = ({ locations }) => ({
  locations: locations.activeMarketLocations,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  clearHeatMapData: routeActions.clearHeatMapData,
  fetchLocations: locationActions.fetchLocations,
}, dispatch);

const HeatMap = connect(
  mapStateToProps,
  mapDispatchToProps,
)(withRouter(BaseHeatMap));
export { BaseHeatMap, HeatMap };
export default HeatMap;
